<template>
  <div id="error">
    <h2>Error 500</h2>
  </div>
</template>

<script>
export default {
  name: 'Error500'
}
</script>

<style lang="scss" scoped>
</style>
